/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-expressions */
import React, { useCallback, useContext, useEffect, useState } from "react";
import { initializeXmpp, removeXMPP } from "../chatServices/XMPPservice";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Emitter, { CHAT_CONNECTION_RETRIES } from "../services/event-emitter";

const XMPPContext = React.createContext({ xmpp: null, initXMPP: () => {} });

const XMPPProvider = ({ children }) => {
  let location = useLocation();
  const [xmpp, setXMPP] = useState(null);
  const { logedInUser } = useSelector((state) => state.auth);

  // const {sessionAddress} = useAppSelector(state => state.chat);

  const initXMPP = async () => {
    const user_uuid = localStorage.getItem("user_uuid");
    if (!user_uuid) {
      return;
    }
    if (user_uuid && location?.pathname === "/chat") {
      const xmpp = await initializeXmpp(user_uuid, "matrix@1001", null, {setXMPP});
      setXMPP(xmpp);
    }
  };

  useEffect(() => {
    let connD = setTimeout(async () => {
      initXMPP();
    }, 5000);

    return () => {
      clearTimeout(connD);
    };
  }, [logedInUser, location]);

  useEffect(() => {
    Emitter.on(CHAT_CONNECTION_RETRIES, handleChatConnectionRetries);
    return () => {
      Emitter.off(CHAT_CONNECTION_RETRIES, handleChatConnectionRetries);
    };
  }, []);

  const handleChatConnectionRetries = (data) => {
    if (data >= 10) {
      removeXMPP(() => {
        setXMPP(null);
        console.warn(
          "Chat connection failed after 10 attempts. Please refresh the page to try again."
        );
      });
    }
  };

  return (
    <XMPPContext.Provider value={{ xmpp, initXMPP }}>
      {children}
    </XMPPContext.Provider>
  );
};

const useXMPP = () => {
  const base = useContext(XMPPContext);
  if (base == null) {
    throw new Error("useXMPP() called outside of a XMPPProvider?");
  }
  return base;
};

export { XMPPProvider, useXMPP };
